module.exports = __webpack_public_path__ + "img/time-badge-platinum.95ce8346.svg";